// extracted by mini-css-extract-plugin
export default {"cardContainer":"recom_cardContainer__H1zfG","showCard":"recom_showCard__8Zw8t","editStyle":"recom_editStyle__hNOhB","font20":"recom_font20__YJ0Rz"};